import { createAuthGuard } from 'keycloak-angular';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

export const authGuard = createAuthGuard(
  async (
    _route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    { authenticated, keycloak },
  ) => {
    if (!authenticated) {
      await keycloak.login({
        redirectUri: window.location.origin + state.url,
      });
      return false;
    }
    return true;
  },
);
